import { Controller as BaseController } from 'stimulus'
import { useDispatch } from 'stimulus-use'

export class Controller extends BaseController {
  static targets = ['checkbox']
  static values = { checked: Boolean }

  connect() {
    useDispatch(this)
    this.checkboxTarget.checked = this.checkedValue
  }

  handleToggle() {
    this.dispatch(
      'toggled',
      { id: this.checkboxTarget.value, checked: this.checkboxTarget.checked }
    )
  }
}
